@if (result) {
  <div layout-align-items-center layout-horizontal>
    @if (authorExists) {
      <rt-avatar
        [type]="!result.admin || result.admin.hasAvatar ? 'image' : 'initials'"
        size="small"
        shape="oval"
        [imageSrc]="photoThumbUrl"
        [initials]="initials"
        [context]="result.admin ? 'admin' : 'candidate'"
      />
    }
    @if (!authorExists) {
      <rt-avatar type="icon" size="small" shape="oval" iconName="person" context="admin" />
    }
    <div
      [attr.layout-vertical]="result.interviewTemplateName"
      class="heading-name"
      layout-align-items-start
    >
      <div class="user-name">
        {{ name }}
        @if (result.guest) {
          <rt-badge color="optional" [text]="'app.common.guest' | translate" margin-left-small-x>
          </rt-badge>
        }
      </div>
      <div class="interview-template-name">
        @if (result.interviewTemplateName) {
          <rt-truncate>
            {{ result.interviewTemplateName }}
          </rt-truncate>
        }
        @if (result.interviewTemplateName) {
          <rt-divider variant="dot"></rt-divider>
        }
        <rt-date [time]="result.updatedAt"> </rt-date>
      </div>
    </div>
  </div>
}
